import axios from 'axios';
import log from 'loglevel';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

log.info(`Environment: ${process.env.REACT_APP_ENVIRONMENT_NAME}`);
export const pixagriApiServer =
  process.env.REACT_APP_ENVIRONMENT_NAME === 'prod' || process.env.REACT_APP_ENVIRONMENT_NAME === 'preprod'
    ? `${process.env.REACT_APP_PIXAGRI_SERVER}`
    : `${process.env.REACT_APP_PIXAGRI_DEV_SERVER}`;
export const pixagriApiUrl =
  process.env.REACT_APP_ENVIRONMENT_NAME === 'prod'
    ? `${pixagriApiServer}${process.env.REACT_APP_PIXAGRI_API_PREFIX_PROD}`
    : process.env.REACT_APP_ENVIRONMENT_NAME === 'preprod'
    ? `${pixagriApiServer}${process.env.REACT_APP_PIXAGRI_API_PREFIX_PREPROD}`
    : `${pixagriApiServer}${process.env.REACT_APP_PIXAGRI_API_PREFIX_DEV}`;

export const wagoApiNestServer = 'https://wago-api-';
export const wagoApiServerDevUrl = `${wagoApiNestServer}s2nygtk3nq-ew.a.run.app`; //
export const wagoApiServerPreprodUrl = `${wagoApiNestServer}preprod-ccgfqp5o5q-ew.a.run.app`;
export const wagoApiServerProdUrl = `${wagoApiNestServer}ccgfqp5o5q-ew.a.run.app`;

export const wagoNestApiUrl =
  process.env.REACT_APP_ENVIRONMENT_NAME === 'prod'
    ? `${wagoApiServerProdUrl}/api/v1/agri`
    : process.env.REACT_APP_ENVIRONMENT_NAME === 'preprod'
    ? `${wagoApiServerPreprodUrl}/api/v1/agri`
    : `${wagoApiServerDevUrl}/api/v1/agri`;

// export const wagoNestApiUrl = 'http://localhost:8080/api/v1/agri';
// export const wagoApiServer = `http://localhost:8080`;
// export const wagoApiUrl = `${wagoApiServer}/api`;
export const wagoApiServer =
  process.env.REACT_APP_ENVIRONMENT_NAME === 'prod'
    ? `${wagoApiServerProdUrl}`
    : process.env.REACT_APP_ENVIRONMENT_NAME === 'preprod'
    ? `${wagoApiServerPreprodUrl}`
    : `${wagoApiServerDevUrl}`;

log.info(`Pixagri Api Url: ${pixagriApiUrl}`);

export default axiosInstance;
